import React, { useState, useEffect } from "react"
import urlJoin from "proper-url-join"
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth"
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  Paper,
  createTheme,
  ThemeProvider,
} from "@mui/material"

import Loading from "./Layout/Loading"
import fetchProfile from "../utils/fetchProfile"
import * as localStorage from "../utils/localStorage"
import { auth } from "../firebase"
import firebaseLogin from "../api/firebaseLogin"

// Create a theme with the same primary color as the AppBar
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
  },
})

function Login(props) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const { reload_redirect } = props

  useEffect(() => {
    // Check if user is already signed in
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // User is signed in
          const firebaseToken = await user.getIdToken()

          // Call the firebase-login API to get the API tokens
          const loginResponse = await firebaseLogin(firebaseToken)

          // Store the tokens in localStorage
          localStorage.set("token", loginResponse.token)
          localStorage.set("refresh_token", loginResponse.refresh_token)
          localStorage.set("tokenIssuedAt", new Date().toISOString())

          const profile = await fetchProfile()

          if (!profile) {
            // Fetch profile will redirect to web app
            return
          }

          if (reload_redirect) {
            const url = urlJoin("/", reload_redirect)
            window.location.replace(url)
          } else {
            window.location.replace("/")
          }
        } catch (error) {
          console.error("Error during login process:", error)
          setError("Failed to complete login process. Please try again.")
          setLoading(false)
        }
      }
    })

    return () => unsubscribe()
  }, [reload_redirect])

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError("")

    try {
      await signInWithEmailAndPassword(auth, email, password)
      // Auth state listener will handle the redirect
    } catch (error) {
      setError("Failed to log in: " + error.message)
      setLoading(false)
    }
  }

  if (loading) {
    return <Loading />
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4 }}>
          <img src="/logo.svg" alt="Logo" style={{ maxWidth: "125px", marginBottom: "20px" }} />
        </Box>
        <Paper elevation={3} sx={{ padding: 4, marginTop: 2, backgroundColor: "#f5f5f5" }}>
          <Typography component="h1" variant="h5" align="center" color="primary">
            Sign in
          </Typography>
          {error && (
            <Typography color="error" align="center" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              Sign In
            </Button>
          </Box>
        </Paper>
      </Container>
    </ThemeProvider>
  )
}

export default Login
